export const MENU_ID = 'plan';

/**
 * Needs to match src/packages/routes/src/ui/spa/advanced-roadmaps/index.tsx
 */

export const PLAN_MENU_ANALYTICS = 'plan-menu';
export const PLANS_BASE_PATH = '/jira/plans/:planId/scenarios/:scenarioId';

export const PAGES = {
	dependenciesReport: 'dependencies',
	increments: 'program',
	releases: 'releases',
	summary: 'summary',
	calendar: 'calendar',
	teams: 'teams',
	timeline: 'timeline',
};

export const SECTION_ID = {
	SETTINGS: 'settings',
};
